import React, { useEffect } from 'react';
import { Outlet, useLocation, useSearchParams } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { updateSEOMeta, PAGE_SEO } from '../lib/seo';

export default function MainLayout() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const path = location.pathname;

    if (path === '/' || path === '/login') {
      updateSEOMeta(PAGE_SEO.home);

    } else if (path === '/contact') {
      updateSEOMeta(PAGE_SEO.contact);

    } else if (path === '/docs') {
      // Si un chapitre est actif, on enrichit le titre dynamiquement
      const chap = searchParams.get('chap');
      if (chap) {
        const chapTitle = chap.charAt(0).toUpperCase() + chap.slice(1).replace(/-/g, ' ');
        updateSEOMeta({
          ...PAGE_SEO.docs,
          title: `${chapTitle} — Documentation SuperAsso`,
          path: `/docs?chap=${chap}`,
        });
      } else {
        updateSEOMeta(PAGE_SEO.docs);
      }

    } else if (path === '/legal') {
      updateSEOMeta(PAGE_SEO.legal);

    } else if (path === '/confidentialite') {
      updateSEOMeta(PAGE_SEO.confidentialite);

    } else if (path === '/cgu') {
      updateSEOMeta(PAGE_SEO.cgu);

    } else if (path === '/faq') {
      updateSEOMeta(PAGE_SEO.faq);

    } else {
      // Fallback sur la home pour toute route non listée
      updateSEOMeta(PAGE_SEO.home);
    }
  }, [location, searchParams]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      {/* Contenu de la page avec padding-top pour compenser le Header fixe */}
      <main className="flex-grow">
        <Outlet />
      </main>

      <Footer />

    </div>
  );
}

